// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const GeneralDateFormat = t.struct({
    allowedDateFormats: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'GeneralDateFormat',
    strict: true
});

export const getDefaultState = () => new GeneralDateFormat({
    allowedDateFormats: [],
    key: '',
    value: ''
});

export default GeneralDateFormat;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/general-date-format.js